import { FactoryPreset } from '@ipfabric/utils';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import {
  getPathLookupPresetFromLocalStorage,
  getTopologyPresetFromLocalStorage,
} from 'components/Graph/model/presetLocalStorage';

export const loadPresets: GraphCommandFactory = (cmdContext) => async () => {
  try {
    const presets = await cmdContext.api.request({
      url: '/graphs/presets',
      method: 'GET',
    });

    cmdContext.updateState((draft) => {
      draft.layoutSettings.presets = presets?.length
        ? presets
        : [FactoryPreset];

      const topologyPreset = getTopologyPresetFromLocalStorage(presets);
      const pathLookupPreset = getPathLookupPresetFromLocalStorage();
      draft.layoutSettings.presetDraft = topologyPreset;
      draft.layoutSettings.preset = topologyPreset;
      draft.pathlookup.presetDraft = pathLookupPreset;
      draft.pathlookup.preset = pathLookupPreset;
    });
  } catch (e) {
    cmdContext.updateState((draft) => {
      draft.loading = 'ERROR';
    });
    cmdContext.logError(e, 'GRAPH');
  }
};
